import { useMarkToolbarButton, useMarkToolbarButtonState } from 'platejs/react';
import ToolbarButton from './ToolbarButton';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function MarkToolbarButton({
  clear,
  nodeType,
  ...rest
}) {
  const state = useMarkToolbarButtonState({
    clear,
    nodeType
  });
  const {
    props: {
      pressed,
      onClick
    }
  } = useMarkToolbarButton(state);
  return _jsx(ToolbarButton, {
    isActive: pressed,
    onClick: onClick,
    ...rest
  });
}
export default MarkToolbarButton;